export const validateMultiSales = function (salesData) {
  console.group("validateMultiSales");
  console.log(salesData);
  console.groupEnd();
  let errors = [];
  if (!salesData.hasOwnProperty("selectedSales")) {
    errors[errors.length] = "Fatal Internal error.";
    return errors;
  }
  let sales = salesData.selectedSales;
  if (!Array.isArray(sales)) {
    errors[errors.length] = "Fatal Internal error.";
    return errors;
  }
  const nrSales = sales.length;
  for (let e = 0; e < nrSales; e++) {
    if (sales[e].species === "") {
      errors[errors.length] = "No Species code provided";
    }
    if (sales[e].sold === "") {
      errors[errors.length] = "No Amount sold provided";
    }
    if (sales[e].sold !== "") {
      if (isNaN(sales[e].sold)) {
        errors[errors.length] = "No numeric amount sold provided";
      } else {
        if (Number(sales[e].sold) < 1) {
          errors[errors.length] = "Amount sold must be 1 or larger";
        }
      }
    }
  }
  if (salesData.dealer_permit_number === "") {
    errors[errors.length] = "No Dealer provided";
  }
  if (salesData.dealer_permit_number !== "") {
    if (salesData.date_sold === "") {
      const noSalesValues = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "99998"];
      if (noSalesValues.indexOf(salesData.dealer_permit_number) === -1) {
        errors[errors.length] = "No Sale date provided";
      }
    }
  }
  if (salesData.offloading_port === "") {
    errors[errors.length] = "No Port provided";
  }
  
  return errors;
};

export const validateSales = function (salesData) {
  let errors = [];
  if (salesData.species === "") {
    errors[errors.length] = "No Species code provided";
  }
  if (salesData.sold === "") {
    errors[errors.length] = "No Amount sold provided";
  }
  if (salesData.sold !== "") {
    if (isNaN(salesData.sold)) {
      errors[errors.length] = "No numeric amount sold provided";
    } else {
      if (Number(salesData.sold) < 1) {
        errors[errors.length] = "Amount sold must be 1 or larger";
      }
    }
  }
  if (salesData.dealer_permit_number === "") {
    errors[errors.length] = "No Dealer provided";
  }
  if (salesData.dealer_permit_number !== "") {
    if (salesData.date_sold === "") {
      const noSalesValues = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "99998"];
      if (noSalesValues.indexOf(salesData.dealer_permit_number) === -1) {
        errors[errors.length] = "No Sale date provided";
      }
    }
  }
  if (salesData.offloading_port === "") {
    errors[errors.length] = "No Port provided";
  }

  return errors;
};

// Validates fields included on the clams/lobster feature
export const validateSalesExtra = function (salesData) {
  let errors = [];
  if (
    salesData.price_per_bushel === "" ||
    salesData.price_per_bushel === "NaN" ||
    Number.isNaN(Number(salesData.price_per_bushel))
  ) {
    errors.push("No Price Per Bushels provided");
  }
  if (salesData.allocation_numbers.length === 0) {
    errors.push("No Allocation Numbers provided");
  } else {
    let NrAllocations = salesData.allocation_numbers.length;

    for (let index = 0; index < NrAllocations; index++) {
      let regex = new RegExp("^[a-zA-Z][0-9]{1,}$", "g");
      let currentAlloc = salesData.allocation_numbers[index];
      if (false === regex.test(currentAlloc)) {
        errors.push("Invalid Allocation Numbers provided");
        break;
      }
    }
  }

  if (Object.keys(salesData.tag_numbers).length === 0) {
    errors.push("No Tag Numbers / Range provided");
  } else {
    let NrTagRanges = salesData.tag_numbers.length;
    for (let index = 0; index < NrTagRanges; index++) {
      let currentTag = salesData.tag_numbers[index];
      if (
        (currentTag.hasOwnProperty("start") && Number.isNaN(Number(currentTag.start))) ||
        (currentTag.hasOwnProperty("end") && Number.isNaN(Number(currentTag.end)))
      ) {
        errors.push("Invalid Tag Numbers / Range provided");
        break;
      }
    }
  }

  return errors;
};
